(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brandslider"] && !Shopify.designMode) return;
  try {
    
/* Your JS for initializing owl-carousel / lazyload can remain here or in theme.js */

  } catch(e) { console.error(e); }
})();
})();
